<template>
  <mail-modal ref="modal">
    <mail-modal-title :row="row" />
    <mail-modal-body :row="row" />
  </mail-modal>
</template>

<script>
import MailModal from "@/views/atoms/MailModal";
import MailModalTitle from "@/views/atoms/MailModalTitle";
import MailModalBody from "@/views/atoms/MailModalBody";

export default {
  name: "MailDetailModal",
  components: {
    MailModal,
    MailModalTitle,
    MailModalBody,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
  },
}
</script>
